import { MODAL_ACTIONS } from './constants';

const initialState = [];

const modal = (state = initialState, action) => {
  switch (action.type) {
    case MODAL_ACTIONS.HIDE_ALL_MODAL:
      return [];
    case MODAL_ACTIONS.TOGGLE_MODAL: {
      const modalId = action.payload;
      const newState = [...state];
      const index = state.indexOf(modalId);

      if (index !== -1) {
        newState.splice(index, 1);
      } else {
        newState.push(modalId);
      }

      return newState;
    }
    default:
      return state;
  }
};

export default modal;
